import React from 'react';
import TableRowButtonBtn from './TableRowButtonBtn';

const TableRowButton = (props) => {

  const buttonGroupActive = (props.allowdelete && props.allowdisable) || (props.allowdelete && props.allowchange) || (props.allowadd && props.allowchange) ? true : false;

  return (
    <div>
        {!props.ineditstate && 
        <div className={`action-group action-group-active-${ buttonGroupActive }`}>
            {props.allowreverse &&
              <TableRowButtonBtn
                  color="clear"               
                  onClick={props.onReverseClick}
                  iconclass="icon-blocked no-text"
                  tooltip="Afturkalla bakfærslu"
              ></TableRowButtonBtn>
            } 
            {props.allowdisable &&
              <TableRowButtonBtn
                  color="clear"               
                  onClick={props.onDisableClick}
                  iconclass="icon-blocked no-text"
                  tooltip="Óvirkja / Virkja"
              ></TableRowButtonBtn> 
            } 
            {props.allowdelete &&
              <TableRowButtonBtn
                  color="clear"               
                  onClick={props.onDeleteClick}
                  iconclass="icon-remove2 no-text"
                  tooltip="Eyða"
              ></TableRowButtonBtn> 
            }  
            {props.allowchange &&
              <TableRowButtonBtn
                  color="clear"
                  onClick={props.onChangeClick}
                  iconclass="icon-pencil4 no-text"
                  tooltip="Breyta"
              ></TableRowButtonBtn>
            }
            {props.allowadd &&
              <TableRowButtonBtn
                  color="clear"
                  onClick={props.onAddClick}
                  iconclass="icon-plus-circle no-text"
                  tooltip="Bæta við"
              ></TableRowButtonBtn>
            }
            
        </div>}
        {props.ineditstate && 
        <div className="action-group in-editstate">
            {props.allowsave &&
              <TableRowButtonBtn
                  color="clear"
                  onClick={props.onSaveClick}
                  iconclass="icon-checkmark3 no-text "
                  tooltip="Vista"
              ></TableRowButtonBtn>
            }
            {props.allowcancel &&
              <TableRowButtonBtn
                  color="clear"
                  onClick={props.onCancelClick}
                  iconclass="icon-close2 no-text "
                  tooltip="Hætta við"
              ></TableRowButtonBtn>
            }
        </div>}
    </div>
  );
}

export default TableRowButton;

